import {
  add2suhfggl4zvkk as add,
  subtract2orl8z9upxd9l as subtract,
  fromInt2ii0rejb1w62w as fromInt,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/internal/longAsBigInt/longAsBigInt.mjs';
import { Buffergs925ekssbch as Buffer } from '../../../../../kotlinx-io-kotlinx-io-core/kotlinx/io/Buffer.mjs';
import {
  awaitContent$default2jefvu0cvwa0w as awaitContent$default,
  ByteReadChannel2wzou76jce72d as ByteReadChannel,
} from './ByteReadChannel.mjs';
import { protoOf180f3jzyo7rfj as protoOf } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function transferFromDelegate($this) {
  updateConsumed($this);
  var appended = $this.o4p_1.u4k($this.n4p_1.g4n());
  $this.p4p_1 = add($this.p4p_1, appended);
}
function updateConsumed($this) {
  $this.q4p_1 = add($this.q4p_1, subtract($this.p4p_1, $this.o4p_1.q2()));
  $this.p4p_1 = $this.o4p_1.q2();
}
var CountedByteReadChannelClass;
function CountedByteReadChannel() {
  if (CountedByteReadChannelClass === VOID) {
    class $ {
      constructor(delegate) {
        this.n4p_1 = delegate;
        this.o4p_1 = new (Buffer())();
        this.p4p_1 = 0n;
        this.q4p_1 = 0n;
      }
      r4p() {
        updateConsumed(this);
        return this.q4p_1;
      }
      t4n() {
        return this.n4p_1.t4n();
      }
      y4n() {
        return this.o4p_1.v3z() && this.n4p_1.y4n();
      }
      g4n() {
        transferFromDelegate(this);
        return this.o4p_1;
      }
      *z4n(min, $completion) {
        if (this.g4n().q2() >= fromInt(min)) {
          return true;
        }
        if (yield* this.n4p_1.z4n(min, $completion)) {
          transferFromDelegate(this);
          return true;
        }
        return false;
      }
      j4o(cause) {
        this.n4p_1.j4o(cause);
        this.o4p_1.l6();
      }
    }
    protoOf($).f4o = awaitContent$default;
    initMetadataForClass($, 'CountedByteReadChannel', VOID, VOID, [ByteReadChannel()], [1]);
    CountedByteReadChannelClass = $;
  }
  return CountedByteReadChannelClass;
}
function counted(_this__u8e3s4) {
  return new (CountedByteReadChannel())(_this__u8e3s4);
}
//region block: exports
export {
  counted as counted3iniv3aql3f9n,
};
//endregion

//# sourceMappingURL=CountedByteReadChannel.mjs.map
